module.exports = __webpack_public_path__ + "img/ssb_menu3.6f59d33f.png";